<template>
  <div>
    <!-- 方案明细 -->
    <div class="trade-order-block">
      <div class="block-content">
        <el-row class="content-row">
          <el-col :span="3">分配服务商</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.vendorName || '' }}</el-col>
          <el-col :span="3">服务商联系人</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.vendorContactPerson || '' }}</el-col>
        </el-row>
        <el-row class="content-row">
          <el-col :span="3">服务商联系电话</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.vendorContactPhone || '' }}</el-col>
          <template v-if="hasSupplierQuote()">
            <el-col :span="3">供应商报价金额</el-col>
            <el-col :span="9">{{ tradeApplyInfoVO.quoteAmount | thousandSymbol}}元</el-col>
          </template>
        </el-row>
        <el-row class="content-row" v-if="tradeApplyInfoVO.investTotal">
          <el-col :span="3">本单销售预估金额</el-col>
          <el-col :span="9">{{ tradeApplyInfoVO.investTotal | thousandSymbol }}元</el-col>
        </el-row>
        <el-row class="content-row" v-if="hasBudgetInfo()">
          <template v-if="tradeApplyInfoVO.quotaDTO && !tradeApplyInfoVO.trCode">
            <el-col :span="3">使用的预算</el-col>
            <el-col :span="9">{{ tradeApplyInfoVO.quotaDTO.quotaName }}</el-col>
          </template>
        </el-row>
        <el-row class="content-row" v-if="hasSupplierQuote()">
          <el-col :span="3">测量表及设计图</el-col>
          <el-col :span="21" class="detail-file" v-viewer="{movable: true}">
            <div v-for="(item, index) in planList" :key="index" class="detail-file-content">
              <img v-if="item.acceptanceCode[0] === 'I'" :src="getImg(item.fileUri)" />
              <div v-else>
                <a :href="getFile(item.fileUri)"> {{ item.acceptanceName + '' }} </a>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

      <!-- 费用明细 -->
      <div v-if="tradeApplyInfoVO.tradeApplyAcceptanceVO">
        <div class="block-title block-sub-title" v-if="itemDetailList.length">费用明细</div>
        <div class="block-content" v-if="itemDetailList.length">
          <!-- 物料定制 -->
          <div class="block-content-title" v-if="materialList.length">门店定制</div>
          <div class="block-content-table" v-if="materialList.length">
            <el-row class="table-title">
              <el-col :span="6">物料名称</el-col>
              <el-col :span="6">数量</el-col>
              <el-col :span="6">单价</el-col>
              <el-col :span="6">总价</el-col>
            </el-row>
            <el-row class="table-row" v-for="(item, index) in materialShowList" :key="index">
              <el-col :span="6">{{ item.itemName }}</el-col>
              <el-col :span="6">{{ item.itemQty | thousandSymbol }}</el-col>
              <el-col :span="6">{{ item.itemPrice | thousandSymbol }}</el-col>
              <el-col :span="6">{{ item.itemSum | thousandSymbol }}</el-col>
            </el-row>
            <div class="table-row-more" v-show="materialList.length > 3" @click="handleTable(1)">
              <i :class="[ materialShowList === materialList ? 'el-icon-arrow-up' : 'el-icon-arrow-down']" />
              {{ materialShowList === materialList ? '收起' : '查看更多' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { commonUtils } from '@/utils/common'

export default {
  name: 'order-plan-detail',
  data () {
    return {
      tradeApplyInfoVO: '',
      planList: [], // 测量表及设计图
      itemDetailList: [],
      materialList: [], // 物料定制
      materialShowList: []
    }
  },
  methods: {

    setPlanInfo (info) {
      this.tradeApplyInfoVO = info
      if (this.tradeApplyInfoVO.tradeApplyAcceptanceVO) {
        this.planList = this.tradeApplyInfoVO.tradeApplyAcceptanceVO.planList || []
        this.itemDetailList = this.tradeApplyInfoVO.tradeApplyAcceptanceVO.quoteItemDetailList  || []
      }
      // this.shopList = []
      this.materialList = []
      // 费用明细
      if (this.itemDetailList.length) {
        this.materialList = this.itemDetailList
        this.materialShowList = this.materialList.slice(0, 3)
      }
    },

    // 供应商报价返回 状态250 及以后
    hasSupplierQuote () {
      if (this.tradeApplyInfoVO.solutionStatus >= 250) {
        return true
      } else {
        return false
      }
    },

    // tm 已选预算 成本中心等信息 状态260及以后
    hasBudgetInfo () {
      if (this.tradeApplyInfoVO.solutionStatus >= 260) {
        return true
      } else {
        return false
      }
    },

    handleTable (val) {
      if (val === 1) {
        if (this.materialShowList.length <= 3) {
          this.materialShowList = this.materialList
        } else {
          this.materialShowList = this.materialList.slice(0, 3)
        }
      }
    },

    getImg (uri) {
      return commonUtils.getImageUrl(uri)
    },

    getFile (uri) {
      return commonUtils.getFileUrl(uri)
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-file {
  display: flex;
  align-items: center;

  .detail-file-content {
    width: 100px;
    height: 120px;
    margin-right: 20px;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      cursor: pointer;
      border-radius: 4px;
    }
  }

  a, a:hover {
    color: $base-blue !important;
  }
}

.block-content-title {
  color: $base-red;
  padding: 15px 0 5px 5px;
}
.block-content-table {
  .el-row {
    line-height: 40px;
    text-align: center;
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }

  .table-title {
    font-weight: bold;
    background-color: #ebf4ff;
  }

  .table-row-more {
    color: $base-blue;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 8px;
    cursor: pointer;

    .el-icon-arrow-down,
    .el-icon-arrow-up {
      font-weight: bold;
      font-size: 18px;
      padding-right: 2px;
    }
  }
}
</style>
